import { AppConstants } from '@app/core/constants/app.constants';
import { LOG_LEVEL, LogLevel } from './log-level';

type LoggerAny = unknown;

const logValueMap: Record<LogLevel, number> = {
  NONE: 0,
  ERROR: 1,
  WARN: 2,
  INFO: 3,
  TRACE: 4
};

export class Logger {
  private static _level: LogLevel = AppConstants.logLevel;

  private static log(message: LoggerAny, level: LogLevel, params: LoggerAny[]) {
    if (Logger.shouldLog(level)) {
      switch (level) {
        case LOG_LEVEL.ERROR:
          console.error(message, ...params);
          break;
        case LOG_LEVEL.TRACE:
          console.log(message, ...params);
          break;
        case LOG_LEVEL.WARN:
          console.warn(message, ...params);
          break;
        case LOG_LEVEL.INFO:
          console.info(message, ...params);
          break;
        default:
          console.debug(message, ...params);
      }
    }
  }

  private static shouldLog(level: LogLevel) {
    return logValueMap[this._level] >= logValueMap[level];
  }

  static error(message: LoggerAny, ...optionalParams: LoggerAny[]) {
    Logger.log(message, LOG_LEVEL.ERROR, optionalParams);
  }

  static warn(message: LoggerAny, ...optionalParams: LoggerAny[]) {
    Logger.log(message, LOG_LEVEL.WARN, optionalParams);
  }

  static info(message: LoggerAny, ...optionalParams: LoggerAny[]) {
    Logger.log(message, LOG_LEVEL.INFO, optionalParams);
  }

  static trace(message: LoggerAny, ...optionalParams: LoggerAny[]) {
    Logger.log(message, LOG_LEVEL.TRACE, optionalParams);
  }
}
